module.exports = __webpack_public_path__ + "static/media/sidebar-arrow-button.620c209d.png";